<template>
  <main id="account" class="page-container">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="errorMessage2"
      :class="{ 'error-message': true, show: errorMessage2 }"
    >
      {{ errorMessage2 }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p>
    <p
      v-if="successMessage2"
      :class="{ 'success-message': true, show: successMessage2 }"
    >
      {{ successMessage2 }}
    </p> -->

    <!-- Form principale -->
    <form class="create-account-form" @submit.prevent="handleSubmit">
      <h3><strong>Cambio Password</strong></h3>
      <!-- RIGA 1: account email, old/new password -->
      <div class="create-account-row row-1">
        <div class="field">
          <label for="account-email1">Email</label>
          <input
            id="account-email1"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailStep1"
            autocomplete="email"
            required
          />
        </div>

        <div class="field" v-if="step === 1">
          <!-- Vecchia Password -->
          <label v-if="step === 1" for="old-password">Vecchia Password</label>
          <div class="account-password-field">
            <input
              v-if="step === 1"
              id="old-password"
              :type="showPassword1 ? 'text' : 'password'"
              placeholder="Inserisci vecchia password"
              v-model="oldPassword"
              autocomplete="current-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword1"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword1" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="field" v-if="step === 2">
          <!-- Nuova Password -->
          <label v-if="step === 2" for="account-password1"
            >Nuova Password</label
          >
          <div class="account-password-field">
            <input
              v-if="step === 2"
              id="account-password1"
              :type="showPassword2 ? 'text' : 'password'"
              placeholder="Inserisci nuova password"
              v-model="newPasswordStep2"
              autocomplete="new-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword2"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword2" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="save-button-container">
          <button
            type="submit"
            id="change-password"
            :disabled="
              !emailStep1 || (step === 1 ? !oldPassword : !newPasswordStep2)
            "
          >
            {{ step === 1 ? "Verifica vecchia password" : "Aggiorna password" }}
          </button>
        </div>
      </div>
    </form>

    <hr />
    <!-- [sc-48692] Il form resta, spento: gli operatori li crea liberotratto. -->
    <form
      v-if="features.customerCreatesOperators && isAdmin"
      class="create-account-form"
      @submit.prevent="createNewAdmin"
    >
      <h3><strong>Aggiungi admin</strong></h3>

      <!--
        [sc-48350 / task 48393] Ogni azienda può registrare un numero massimo
        di operatori. Il tetto lo applica comunque l'API: qui serve solo a dirlo
        prima, invece di far scrivere email e password per poi rifiutarle.
      -->
      <p
        v-if="seatsLoaded"
        class="seats-note"
        :class="{ full: seatsExhausted }"
      >
        <template v-if="seatsExhausted">
          Limite raggiunto: questa azienda può registrare al massimo
          {{ seats.max }} operatori. Per aggiungerne un altro archivia prima uno
          di quelli esistenti.
        </template>
        <template v-else>
          {{ postiRegistrati }}
        </template>
      </p>

      <!-- RIGA 2: account email, password -->
      <div class="create-account-row row-2">
        <div class="field">
          <!-- account email -->
          <label for="account-email2">Aggiungi admin</label>
          <input
            id="account-email2"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailAdmin"
            autocomplete="email"
            :disabled="seatsExhausted"
            required
          />
        </div>

        <div class="field">
          <!-- password -->
          <label for="get-password">Password</label>
          <div class="account-password-field">
            <input
              id="get-password"
              :type="showAdminPassword ? 'text' : 'password'"
              placeholder="Password"
              v-model="passwordAdmin"
              autocomplete="current-password"
              :disabled="seatsExhausted"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="toggleAdminPassword"
            >
              <!-- Se showAdminPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showAdminPassword" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="save-button-container">
          <button
            id="add-admin"
            type="submit"
            :disabled="
              isReadOnly || !emailAdmin || !passwordAdmin || seatsExhausted
            "
          >
            Aggiungi admin
          </button>
        </div>
      </div>
    </form>
    <section v-else class="create-account-form operators-request">
      <h3><strong>Operatori</strong></h3>
      <!-- [sc-48692] Posti finiti: stesso riquadro della console, non la riga
           rossa del vecchio form. È lo stato dell'azienda, non un errore. -->
      <div v-if="seatsExhausted" class="operators-notice" role="status">
        <p>
          <strong>Posti esauriti:</strong> {{ seats.used }} su
          {{ seats.max }} operatori.
        </p>
      </div>
      <p v-else-if="seatsLoaded" class="seats-note">
        {{ postiRegistrati }}
      </p>
      <!-- [sc-48692] Solo con un posto libero: a posti finiti liberotratto non
           potrebbe creare nessuno. L'indirizzo del collega serve a mandare
           l'invito alla persona giusta, e l'email si apre già con la riga per
           scriverlo. L'indirizzo di liberotratto si vede per intero: chi usa
           una webmail il mailto non lo apre, e deve poterlo copiare. -->
      <!-- [sc-48351 / task 48786] Gestire gli operatori è dell'amministratore:
           gli altri ruoli vedono solo il conteggio. -->
      <p v-if="!seatsExhausted && isAdmin" class="seats-note">
        Per aggiungere un operatore scrivi a
        <a v-if="linkNuovoOperatore" :href="linkNuovoOperatore">{{
          emailLiberotratto
        }}</a>
        <template v-else>Liberotratto</template>
        indicando l'indirizzo email del collega: gli mandiamo noi l'invito per
        scegliere la password. Per entrare gli servirà un codice, che generi da
        questa pagina.
      </p>

      <!-- [sc-48692] Codice a due canali: il link arriva al collega per email,
           il codice lo genera l'amministratore qui e glielo dà a voce. -->
      <!-- [sc-48351 / task 48786] Il ruolo di ogni operatore, scelto
           dall'amministratore. L'ultimo amministratore non si declassa: la
           tendina resta chiusa e il titolo dice perché. -->
      <div v-if="gestisceRuoli && operatori.length" class="operators-invites">
        <h4 class="operators-invites__title">Ruoli degli operatori</h4>
        <p class="seats-note">
          I permessi di ogni ruolo li decidi nella pagina
          <router-link to="/home/ruoli">Ruoli</router-link>.
        </p>
        <ul class="operators-invites__list">
          <li
            v-for="operatore in operatori"
            :key="operatore.id"
            class="operators-invite"
          >
            <div class="operators-invite__who">
              <span class="operators-invite__email">{{
                operatore.operatorName
              }}</span>
              <span class="operators-invite__state">{{ operatore.email }}</span>
            </div>
            <StatusSelect
              class="operators-role__select"
              :modelValue="valoreRuolo(operatore)"
              :options="opzioniRuolo(operatore)"
              placeholderIcon="fa-user-shield"
              :disabled="
                isReadOnly ||
                cambiandoRuolo === operatore.id ||
                unicoAmministratore(operatore, operatori)
              "
              :title="
                unicoAmministratore(operatore, operatori)
                  ? 'È l\'unico Admin: prima dai il ruolo Admin a un altro operatore'
                  : ''
              "
              :aria-label="`Ruolo di ${operatore.operatorName}`"
              @update:modelValue="scegliRuolo(operatore, $event)"
            />
          </li>
        </ul>
      </div>

      <div v-if="isAdmin && inviti.length" class="operators-invites">
        <h4 class="operators-invites__title">Colleghi invitati</h4>
        <p class="seats-note">
          Liberotratto ha mandato l'invito a questi indirizzi. Per entrare,
          oltre alla password, serve un codice che generi tu: fallo solo se
          riconosci l'indirizzo, e daglielo a voce.
        </p>
        <!-- [sc-48692] Il pulsante spento va spiegato: a prova finita generare
             il codice è una scrittura, e l'azienda si legge e basta. -->
        <div v-if="isReadOnly" class="operators-notice" role="status">
          <p>
            <strong>Prova finita:</strong> l'azienda è in sola lettura, quindi
            il codice non si può generare. Attiva l'abbonamento per far entrare
            il collega.
          </p>
        </div>
        <ul class="operators-invites__list">
          <li
            v-for="invito in inviti"
            :key="invito.id"
            class="operators-invite"
          >
            <div class="operators-invite__who">
              <span class="operators-invite__label">Invito per</span>
              <span class="operators-invite__email">{{ invito.email }}</span>
              <span
                v-for="riga in righeInvito(invito)"
                :key="riga"
                class="operators-invite__state"
                >{{ riga }}</span
              >
              <span
                v-if="invito.codiceGenerato && !codici[invito.id]"
                class="operators-invite__state"
              >
                Codice già generato: se il collega non ce l'ha, generane uno
                nuovo.
              </span>
            </div>

            <!-- Il codice diviso 3+3 si detta meglio; le due metà sono
                 attaccate, quindi copiandolo restano sei cifre. -->
            <div v-if="codici[invito.id]" class="operators-invite__result">
              <strong
                class="operators-invite__code"
                :aria-label="`Codice ${codici[invito.id]}`"
                ><span>{{ codici[invito.id].slice(0, 3) }}</span
                ><span>{{ codici[invito.id].slice(3) }}</span></strong
              >
              <span class="operators-invite__hint">
                Il codice si vede solo adesso. Dallo a voce, non per email né in
                chat. Generarne un altro annulla questo.
              </span>
            </div>
            <button
              v-else
              type="button"
              class="operators-invite__btn"
              :disabled="isReadOnly || generando === invito.id"
              @click="generaCodice(invito)"
            >
              {{
                generando === invito.id
                  ? "Generazione…"
                  : invito.codiceGenerato
                  ? "Genera un nuovo codice"
                  : "Genera codice"
              }}
            </button>
          </li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
import { setAuth } from "../router";
import { mailtoNuovoOperatore } from "@/utilities/abbonamento";
import { formatPlatformDateTime } from "@/utilities/platformFormat";
import StatusSelect from "@/components/StatusSelect.vue";
import {
  VALORE_AMMINISTRATORE,
  corpoRuolo,
  unicoAmministratore,
  valoreRuolo,
} from "@/utilities/ruoli";

export default {
  components: { StatusSelect },
  data() {
    return {
      operatorName: "",
      step: 1, // Step iniziale
      emailStep1: "",
      oldPassword: "",
      newPasswordStep2: "",
      emailAdmin: "",
      passwordAdmin: "",
      errorMessage: "",
      errorMessage2: "",
      successMessage: "",
      successMessage2: "",
      showPassword1: false, // controlla se la password è visibile
      showPassword2: false,
      showAdminPassword: false,
      // [sc-48350 / task 48393] Posti operatore dell'azienda.
      seats: { used: 0, max: 0, available: 0 },
      seatsLoaded: false,
      // [sc-48692] Colleghi invitati in attesa, e i codici generati in questa
      // visita: si vedono una volta, ricaricando la pagina spariscono.
      inviti: [],
      codici: {},
      generando: null,
      // [sc-48351 / task 48786] Operatori e ruoli, per la tendina.
      operatori: [],
      ruoli: [],
      cambiandoRuolo: null,
    };
  },
  computed: {
    /**
     * Funzioni accese per l'azienda collegata.
     * [sc-48351] Dal piano dell'azienda, via store, non più da `features.js`.
     */
    features() {
      return this.$store.getters["company/features"];
    },
    isAdmin() {
      return Boolean(this.$store.state.currentUser?.isAdmin);
    },
    /** [sc-48351 / task 48786] I ruoli sono di PLUS e li dà l'amministratore. */
    gestisceRuoli() {
      return this.isAdmin && Boolean(this.features?.roles);
    },
    // [sc-48692] A chi scrivere, da mostrare per intero accanto al mailto.
    emailLiberotratto() {
      return process.env.VUE_APP_SALES_EMAIL || "";
    },
    // [sc-48692] La richiesta di un operatore in più, già scritta.
    linkNuovoOperatore() {
      return mailtoNuovoOperatore(
        this.$store?.getters?.["company/branding"]?.name
      );
    },
    // Finché i posti non sono noti il form resta utilizzabile: se la chiamata
    // fallisce è meglio provarci e ricevere il rifiuto dall'API che bloccare
    // l'admin per un errore di rete.
    // [sc-48351] Un'azienda PLUS non ha tetto: `max` e `available` arrivano
    // `null`, e `null <= 0` in JavaScript è vero. Senza il primo controllo
    // un'azienda senza tetto risulterebbe sempre a posti finiti.
    seatsExhausted() {
      return (
        this.seatsLoaded && this.seats.max !== null && this.seats.available <= 0
      );
    },
    /** [sc-48351] «2 di 2» per START; senza tetto si dice solo quanti sono. */
    postiRegistrati() {
      if (this.seats.max === null) {
        return `Operatori registrati: ${this.seats.used}.`;
      }
      return `Operatori registrati: ${this.seats.used} di ${this.seats.max}.`;
    },
  },
  async mounted() {
    await this.loadSeats();
    // [sc-48692] Gli inviti servono solo quando gli operatori li crea
    // liberotratto: è qui che l'amministratore genera il codice.
    // [sc-48351 / task 48786] Solo all'amministratore: per gli altri ruoli
    // l'API risponde 403.
    if (this.isAdmin && !this.features.customerCreatesOperators) {
      await this.loadInviti();
    }
    if (this.gestisceRuoli) await this.loadRuoli();
  },
  methods: {
    valoreRuolo,
    unicoAmministratore,
    async loadRuoli() {
      try {
        const [operatori, ruoli] = await Promise.all([
          this.$axios.get("/auth/get-all"),
          this.$axios.get("/roles"),
        ]);
        this.operatori = Array.isArray(operatori.data) ? operatori.data : [];
        this.ruoli = Array.isArray(ruoli.data?.roles) ? ruoli.data.roles : [];
      } catch (error) {
        this.operatori = [];
        console.error("Errore durante il fetch di operatori e ruoli:", error);
      }
    },
    /**
     * Le voci della tendina del ruolo. «Nessun ruolo» si vede solo per chi
     * non ne ha uno, e non si sceglie.
     */
    opzioniRuolo(operatore) {
      return [
        { value: VALORE_AMMINISTRATORE, label: "Admin" },
        ...(valoreRuolo(operatore)
          ? []
          : [{ value: "", label: "Nessun ruolo", disabled: true }]),
        ...this.ruoli.map((r) => ({ value: String(r.id), label: r.name })),
      ];
    },
    /**
     * La tendina della piattaforma riemette anche la voce già scelta, il
     * `<select>` no: si chiama l'API solo se il ruolo cambia davvero.
     */
    scegliRuolo(operatore, valore) {
      if (valore === valoreRuolo(operatore)) return;
      this.cambiaRuolo(operatore, valore);
    },
    async cambiaRuolo(operatore, valore) {
      this.cambiandoRuolo = operatore.id;
      try {
        const { data } = await this.$axios.patch(
          `/auth/operators/${operatore.id}/role`,
          corpoRuolo(valore)
        );
        this.operatori = this.operatori.map((o) =>
          o.id === data.id
            ? { ...o, isAdmin: data.isAdmin, roleId: data.roleId }
            : o
        );
        // Chi cambia il proprio ruolo cambia quello che vede: si riparte dal
        // profilo, e la guardia lo porta dove può stare.
        if (operatore.id === this.$store.state.currentUser?.id) {
          window.location.assign(this.$router.resolve({ name: "home" }).href);
          return;
        }
        this.$toast.success("Ruolo aggiornato.");
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message || "Ruolo non cambiato."
        );
        // La tendina torna a dire il vero.
        await this.loadRuoli();
      } finally {
        this.cambiandoRuolo = null;
      }
    },
    async loadSeats() {
      try {
        const response = await this.$axios.get("/auth/seats");
        this.seats = response.data;
        this.seatsLoaded = true;
      } catch (error) {
        this.seatsLoaded = false;
        console.error("Errore durante il fetch dei posti operatore:", error);
      }
    },
    /**
     * [sc-48692] Lo stato di un invito in frasi intere: chi l'ha mandato e
     * quando, e fino a quando vale il link. «in attesa, scade il …» diceva lo
     * stato del link, non a chi fosse andato né cosa fare se scade.
     */
    righeInvito(invito) {
      const righe = [];
      if (invito?.inviatoIl) {
        righe.push(
          `Mandato da Liberotratto il ${formatPlatformDateTime(
            invito.inviatoIl
          )}.`
        );
      }
      if (invito?.invito?.stato === "in_attesa") {
        righe.push(
          `Il link per scegliere la password vale fino al ${formatPlatformDateTime(
            invito.invito.scade
          )}.`
        );
      } else {
        righe.push(
          "Il link per scegliere la password è scaduto: chiedi a Liberotratto di rimandare l'invito."
        );
      }
      return righe;
    },
    async loadInviti() {
      try {
        const { data } = await this.$axios.get("/auth/invites");
        this.inviti = Array.isArray(data) ? data : [];
      } catch (error) {
        this.inviti = [];
        console.error("Errore durante il fetch degli inviti:", error);
      }
    },
    // [sc-48692] Il codice torna una volta sola: lo si tiene in pagina finché
    // l'amministratore non l'ha dettato.
    async generaCodice(invito) {
      this.generando = invito.id;
      try {
        const { data } = await this.$axios.post(
          `/auth/invites/${invito.id}/code`
        );
        this.codici = { ...this.codici, [invito.id]: data.codice };
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message || "Codice non generato."
        );
        await this.loadInviti();
      } finally {
        this.generando = null;
      }
    },
    togglePassword1() {
      // Inverte lo stato showPassword1
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2() {
      // Inverte lo stato showPassword2
      this.showPassword2 = !this.showPassword2;
    },
    toggleAdminPassword() {
      // Inverte lo stato showAdminPassword
      this.showAdminPassword = !this.showAdminPassword;
    },
    async handleSubmit() {
      if (this.step === 1) {
        // Step 1: Verifica Vecchia Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.oldPassword,
          };
          const response = await this.$axios.post(
            "/auth/verify-password",
            payload
          );
          // console.log(response);
          if (response.status === 200) {
            this.step = 2; // Passa allo step 2
            this.successMessage =
              "Password verificata! Inserisci la nuova password.";
            this.$toast.success(this.successMessage);
            this.errorMessage = "";
          } else {
            this.errorMessage =
              response.data.details || "Email/password non corretti";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
          }
        } catch (error) {
          this.errorMessage =
            error.response?.data?.message || "Errore durante la verifica.";
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          console.error("Errore durante la verifica password:", error);
        }
      } else if (this.step === 2) {
        // Step 2: Aggiorna Nuova Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.newPasswordStep2,
          };
          const response = await this.$axios.patch(
            "/auth/change-password",
            payload
          );
          if (response.status === 200) {
            this.step = 1;
            this.successMessage2 =
              response.data.details || "Password aggiornata con successo!";
            this.$toast.success(this.successMessage2);
            this.emailStep1 = "";
            this.emailAdmin = "";
            this.errorMessage2 = "";
            this.oldPassword = "";
            this.newPasswordStep2 = "";

            setTimeout(() => {
              setAuth(false); // logout
              // push alla login page dopo 2 secondi
              this.$router.push("/login");
              this.$toast.info("Effettua il login con la nuova password.");
            }, 2000);
          } else {
            this.errorMessage2 =
              response.data.details || "Password già aggiornata alla modifica";
            this.$toast.error(this.errorMessage2);
            this.successMessage2 = "";
          }
        } catch (error) {
          this.errorMessage2 =
            error.response?.data?.message || "Errore durante l'aggiornamento.";
          this.$toast.error(this.errorMessage2);
          this.successMessage2 = "";
          console.error("Errore durante l'aggiornamento password:", error);
        }
      }
    },
    async createNewAdmin() {
      this.errorMessage = "";
      this.successMessage = "";
      try {
        const payload = {
          email: this.emailAdmin,
          password: this.passwordAdmin,
        };
        const response = await this.$axios.post("/auth/create-admin", payload);
        if (response.status === 200) {
          this.successMessage =
            response.data.message || "Admin creato con successo!";
          this.$toast.success(this.successMessage);
          this.emailAdmin = "";
          this.errorMessage = "";
          this.passwordAdmin = "";
          // Un posto in meno: rileggo invece di scalare a mano, così il numero
          // resta giusto anche se un altro admin ha creato un operatore.
          await this.loadSeats();
        } else {
          this.errorMessage =
            response.data.message || "Errore durante la creazione dell'admin"; //response diversa da 200
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
        }
      } catch (error) {
        const data = error.response?.data;
        // `details` è una stringa per gli errori di validazione, ma un oggetto
        // per il tetto operatori ({ max, used }): in quel caso il testo buono
        // da mostrare è `message`, non "[object Object]".
        this.errorMessage =
          (typeof data?.details === "string" ? data.details : data?.message) ||
          "Errore durante la creazione dell'admin.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
        console.error("Errore durante la creazione dell'admin: ", error);
        // Se il rifiuto è il tetto raggiunto, rileggo i posti: da qui in poi il
        // form resta chiuso invece di far riprovare a vuoto.
        if (data?.code === "OPERATOR_LIMIT_REACHED") await this.loadSeats();
      }
    },
  },
};
</script>

<style src="@/css/AccountPage.css"></style>
